import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';

const SubscribeForm = ({ status, message, onSubmitted}) => {

    const { t } = useTranslation();

    const [email, setEmail] = useState('')

    const changeEmail = (e) => {
        setEmail(e.target.value)
    }

    const submitHandler = (e) => {
        e.preventDefault();
        onSubmitted({
            EMAIL: email
          });
    }

    return (
        <form onSubmit={submitHandler} className="footer-form needs-validation" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" target="_blank">
            <div className="form-group">
                <input type="email" className="form-control" placeholder={t('enter your email')} value={email} onChange={changeEmail} name="EMAIL" id="mce-EMAIL" required="required" />
            </div>
            <div className="form-button">
                <button type="submit" className="btn btn-custom theme-color" id="mc-submit">{t('send')}</button>
            </div>
        </form>
    )
}

export default SubscribeForm;


// WEBPACK FOOTER //
// ./src/components/subscribeForm.js